import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";
import { useTranslation } from "react-i18next";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

export const TextMaskCustom = forwardRef<HTMLInputElement, CustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
      />
    );
  }
);
TextMaskCustom.displayName = "TextMaskCustom";

const DocumentTextField = forwardRef<
  HTMLInputElement,
  Omit<TextFieldProps, "label" | "placeholder" | "InputProps">
>((props, ref) => {
  const { t } = useTranslation();
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: TextMaskCustom as never,
        inputProps: {
          pattern: "[0-9]*",
          inputMode: "numeric",
          mask: "000.000.000-00",
        },
      }}
      inputRef={ref}
      label={t("document.cpfLabel")}
      placeholder="000.000.000-00"
      sx={{
        "& .MuiFormLabel-root": {
          color: "primary.main",
        },
        "& .MuiInputBase-input": {
          color: "primary.main",
        },
      }}
    />
  );
});
DocumentTextField.displayName = "DocumentTextField";
export default DocumentTextField;
